import Vue from 'vue'
import './plugins/axios'
import VueRouter from 'vue-router'
import App from './App.vue'
import './plugins/element.js'
import VueHttp from 'vue-resource'
import { routes } from './routes'

Vue.config.productionTip = false
Vue.use(VueHttp)
Vue.use(VueRouter)

const router = new VueRouter({
  routes
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
